/* eslint-disable */
import axios from 'axios';
import { showAlert } from './alerts';

//axios.defaults.baseURL = `${process.env.HOST}:${process.env.PORT}`;
//axios.defaults.baseURL = '127.0.0.1:3000';

export const login = async (email, password) => {
  try {
    const res = await axios({
      method: 'POST',
      url: '/api/users/login',
      data: {
        email,
        password,
      },
      withCredentials: true,
    });

    if (res.data.status === 'success') {
      showAlert('success', 'Logged in succesfully!');
      window.setTimeout(() => {
        location.assign('/');
      }, 1500);
    }
  } catch (err) {
    showAlert('error', err.response.data.message);
  }
};

export const logout = async () => {
  try {
    const res = await axios({
      method: 'GET',
      url: '/api/users/logout',
      //withCredentials: true,
    });

    if ((res.data.status = 'success')) {
      //reload from server
      location.assign('/');
      //location.reload(true);
    }
  } catch (err) {
    console.log(err);
    showAlert('error', 'Error logging out! Try again.');
  }
};
